
import React from "react";
import { TrackingField } from "./TrackingField";
import { TrackingToggle } from "./TrackingToggle";

interface LinkedinAdsSectionProps {
  linkedinPixelId: string;
  setLinkedinPixelId: (value: string) => void;
  linkedinApiToken: string;
  setLinkedinApiToken: (value: string) => void;
  isEditing: boolean;
  isPixelEnabled?: boolean;
  setIsPixelEnabled?: (value: boolean) => void;
  isApiEnabled?: boolean;
  setIsApiEnabled?: (value: boolean) => void;
}

export const LinkedinAdsSection: React.FC<LinkedinAdsSectionProps> = ({
  linkedinPixelId,
  setLinkedinPixelId,
  linkedinApiToken,
  setLinkedinApiToken,
  isEditing,
  isPixelEnabled = true,
  setIsPixelEnabled = () => {},
  isApiEnabled = true,
  setIsApiEnabled = () => {},
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">LinkedIn Ads</h3>
        
        {isEditing && (
          <div className="flex items-center space-x-4">
            <TrackingToggle
              id="linkedin-pixel-enabled"
              label="Activer le pixel"
              checked={isPixelEnabled}
              onChange={setIsPixelEnabled}
            />
            <TrackingToggle
              id="linkedin-api-enabled"
              label="Activer l'API"
              checked={isApiEnabled}
              onChange={setIsApiEnabled}
              disabled={!isPixelEnabled}
            />
          </div>
        )}
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TrackingField
          id="linkedin-pixel-id"
          label="Pixel ID"
          value={linkedinPixelId}
          onChange={setLinkedinPixelId}
          isEditing={isEditing}
          placeholder="Votre Pixel ID LinkedIn"
          disabled={!isPixelEnabled && isEditing}
        />
        <TrackingField
          id="linkedin-api-token"
          label="API Token"
          value={linkedinApiToken}
          onChange={setLinkedinApiToken}
          isEditing={isEditing}
          isPassword={true}
          placeholder="Votre token API LinkedIn"
          disabled={(!isPixelEnabled || !isApiEnabled) && isEditing}
        />
      </div>
    </div>
  );
};
